export default {
  // payservice
  getRechargeTradeSerial: '/payservice/api/getMiniOutTradeNoForPayCard',
  getPendingPaymentTable: '/payservice/api/getPaySelfList', // 待缴费列表
  getPaymentInfo: '/payservice/api/getPayOrderFeeList', // 缴费详情
  getRechargeRecordTable: '/payservice/api/selectPayCardBillByPat/{0}/{1}/{2}', // 充值记录列表
  getRechargeRecordTableByAccount: '/payservice/api/selectPayCardForPage', // 充值记录列表（账户信息）
  paymentCard: '/payservice/api/doPayPhysicalNoPay', // 体检缴费（就诊卡支付-待缴费处方）
  paymentSocialSecurityCard: '/payservice/api/getPayInsuranceOutTradeNoForPayPhysical', // 体检缴费（社保卡支付-待缴费处方）
  getPaymentTradeSerial: '/payservice/api/getOutTradeNoForPayPhysical', // 体检缴费（当前账户支付-待缴费处方）
  getPhysicalPaymentTable: '/payservice/api/getPayPhysicalData', // 体检待缴费列表
  getRecipelInfo: '/payservice/api/getPaySelfData', // 处方信息
  getRecipelInfoFinalStatement: '/payservice/api/getPaySelfShow', // 处方信息（结算单模式）
  getRecipelInfoScanCode: '/payservice/api/getPaySelfDataByAppId', // 处方信息（扫码模式，不登录）
  getRecipelInfoSpecial: '/payservice/api/getPaySelfDataResultJson', // 处方信息（泰安中心医院）
  paymentRecipelCard: '/payservice/api/doPaySelfNoPay', // 处方缴费（就诊卡）
  paymentRecipelMedicare: '/payservice/api/dw_health_care/hospital_placeOrder', // 处方缴费（医保）
  getHospitalInformationForMedicare: '/payservice/api/dw_health_care/gethospital', // 医院信息（医保支付时使用）
  queryMedicareOrderResult: '/payservice/api/dw_health_care/queryOrder', // 医保支付结果
  getMedicareCapacityTable: '/payservice/api/dw_health_care/personnelType_sn', // 医保身份列表
  getPaymentRecipelMiniTradeSerial: '/payservice/api/getMiniOutTradeNoForPaySelf', // 处方缴费（当前账户，小程序）
  getPaymentRecipelTradeSerial: '/payservice/api/getOutTradeNoForPaySelf', // 处方缴费（当前账户）
  getRechargeAntigen: '/payservice/api/getMiniOutTradeNoForAntigen', // 抗原检测充值（抗原/核酸直接支付时使用)
  pcRechargeScanQR: '/payservice/api/outGetEncodeQrcode', // [PC]充值扫码付
  pcUpdateRechargeScanQR: '/payservice/api/getQrcodeOutTradeNoForPayCard', // [PC]充值扫码付
  // pay
  verifyBindSocialSecurityCard: '/pay/api/payInsuranceGetmedInfo', // 用户是否社保卡
  verifyCreditPayment: '/pay/api/creditPay/userCheck', // 惠民信用就医支付校验（是否签约结果及是否额度充足结果）
  // payassist
  storePaymentParameter: '/payassist/api/PayNoticeBefore',
  getRefundTable: '/payassist/api/queryOrderForRefund', // 退款列表
  getRefundRecordOrder: '/payassist/api/queryRefundApplyOrders', // 线上退款记录查询接口
  createRefund: '/payassist/api/doRefundApply', // 退款申请
  separateTradeInformation: '/payassist/api/creatPayOrderByXYD', // 三方支付平台下单，使用与原 H5相同接口
  getIp: '/payassist/api/getIp', // 调取 IP
  verifyRechargeResult: '/pay/api/verifydata' // 调取订单状态
};
